import "./style.scss";
import $ from "jquery";

$(function () {
    $('.menu-side__item--has-children > .menu-side__item-link').on("click", function () {
        if ($(this).parent().hasClass("active")) {
            $('.menu-side__item--has-children').removeClass("active");
        } else {
            $('.menu-side__item--has-children').removeClass("active");
            $(this).parent().addClass("active");
        }
    });
});